<template>
  <div class="tw-fixed tw-top-0 tw-left-0">
    <div class="sm:tw-hidden">Mobile</div>
    <div class="tw-hidden sm:tw-block md:tw-hidden">SM</div>
    <div class="tw-hidden md:tw-block lg:tw-hidden">MD</div>
    <div class="tw-hidden lg:tw-block xl:tw-hidden">LG</div>
    <div class="tw-hidden xl:tw-block">XL</div>
  </div>
</template>
<script>
export default {

}
</script>